import gql from "graphql-tag";

export const SEND_PASSWORD_RESET_EMAIL_MUTATION = gql`
  mutation sendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email)
  }
`;
